import React from "react";
import { Col, Row } from "antd";
import { LoadingSpinner, Card, Icon, Switcher, Tooltip, AccordionV2, EmptyStateV2 } from "pepsico-ds";
import SingleSelectDropdown from "../../../components/Dropdown/SingleSelectDropdown";
import ResinLineChart from "../../../components/Charts/ResinChart/ResinLineChart";
import DropdownWithIcons from "../../../components/Modal/DropdownWithIcons";
import { SkeletonList } from "../../../components/Skeleton/ResinSkeleton";
import CmaTable from "../../../components/Table/CmaTable";
import NoData from "../../../components/NoData/NoData";
import reset_icon from "../../../assets/reset_icon.svg";
import { useWoodmacSource } from "./WoodmacSourceContext";

// Woodmac source component. Woodmac pricing-tab state, redux selectors,
// handler functions and effects live in WoodmacSourceContext.js (shared via
// WoodmacSourceProvider) so that Woodmac pricing logic is fully
// self-contained. The Reports tab for Woodmac continues to share its
// date-range/switcher plumbing with SBACCI in the parent (SBACCIScreen.js),
// so those props are still passed down as-is.
const WoodmacSource = props => {
  const {
    section,

    // Reports tab content props (shared with SBACCI in the parent)
    isWoodmacDataLoading,
    renderedWoodmacSections, woodmacAccordionSelectedIndex, cmaPdfReportData,
    renderSection,
    pdfUrl
  } = props;

  const {
    selectedTab,
    woodmacPricingSwitcherIndex, onValueTypeChange,
    geographyList, geographySelected, onGeographyChange,
    isWoodmacLongTermForecastSelected,
    productList, productSelected, onProductChange,
    priceForecastSeriesList, priceForecastSeriesSelected, onWoodmacPriceForecastSeriesChange,
    gradeList, gradeSelected, onGradeChange,
    priceTypeList, priceTypeSelected, onPriceTrypeChange,
    cmaPricingFromDates, cmaPricingFromDatesSelected, onPETResinFromDateChange,
    cmaPricingToDates, cmaPricingToDatesSelected, onPETResinToDateChange,
    unitWoodmacLongTermList, unitsWoodmacLongTermSelected,
    unitList, unitsSelected, onUnitsChange,
    renderPricingFilterDropdown,
    resetButtonHandler,
    isUserDataLoading, isFilterDataLoading, isLineDataLoading,
    linechartRef,
    checkPDFDownloaded,
    pricePointSelected,
    priceBasisSelected,
    activePricingLineChartData,
    resinChartData,
    resinLineChartActualData,
    resinForecastStartVal,
    resinSeriesLineChartIndex,
    resinFirstForecastYearMonth,
    resinFirstForecastKeysToBeMergedActualLast,
    currencySymbol,
    renderForecastLegend,
    isTableDataLoading,
    cmaTableRef,
    activePricingTableData,
    cmaColumns
  } = useWoodmacSource();

  return (
    <>
      {/* Pricing Tab Dropdown Options in Woodmac */}
      {section === "filters" && selectedTab === 1 && (
        <>
          <Row
            gutter={[10, 10]} justify="start" style={{ width: "100%", marginTop:"12px" }}
          >
            <div >
              <Switcher
                className=""
                items={[
                  {
                    label: "Actuals",
                    leadingIcon: "edit",
                    showLeadingIcon: false,
                  },
                  {
                    label: "Short Term Forecast",
                    leadingIcon: "edit",
                    showLeadingIcon: false,
                  },
                  {
                    label: "Long Term Forecast",
                    leadingIcon: "edit",
                    showLeadingIcon: false,
                  }
                ]}
                selectedItemIndex={woodmacPricingSwitcherIndex}
                onUpdate={val => {
                  onValueTypeChange(val)
                }}
                style={{
                  marginRight: "0.5rem"
                }}
              />
              <Tooltip direction="right" 
                  text={(
                    <>
                    <div>
                        <div><strong>Actuals:</strong> Monthly actual prices for PET resin, raw materials and production.</div>
                        <div><strong>Short Term Forecast:</strong> Monthly actual prices for PET resin and raw-material, followed by short-term forecasts (up to next year).</div>
                        <div><strong>Long Term Forecast:</strong> Monthly actual prices of rPET bale, flake and pellet, followed by long term forecasts (for next 3+ years).</div>
                    </div>
                    </>
                  )}>
                  <Icon alt="" icon="info" size="small" style={{ marginRight: "10px" }}/>
              </Tooltip>
            </div>
          </Row>
          <Row
            gutter={[10, 10]}
            justify="start"
            style={{
              width: "100%",
              marginTop: "12px",
              alignItems: "flex-end"
            }}
          >
            {/* {renderPricingFilterDropdown("Geography", geographyList, geographySelected, onGeographyChange, { flex: "1" })} */}
            {isWoodmacLongTermForecastSelected && renderPricingFilterDropdown("Product", productList, productSelected, onProductChange,  { flex: "1" })}
            {!isWoodmacLongTermForecastSelected && renderPricingFilterDropdown("Grade", gradeList, gradeSelected, onGradeChange, { flex: "1" })}
            {renderPricingFilterDropdown("Geography", geographyList, geographySelected, onGeographyChange, { flex: "1" })}
            {isWoodmacLongTermForecastSelected && renderPricingFilterDropdown("Price Forecast Series", priceForecastSeriesList, priceForecastSeriesSelected, onWoodmacPriceForecastSeriesChange,  { flex: "1" })}
            {!isWoodmacLongTermForecastSelected && renderPricingFilterDropdown("Price Type", priceTypeList, priceTypeSelected, onPriceTrypeChange, { flex: "1" })}
            {renderPricingFilterDropdown("Unit of Measure", isWoodmacLongTermForecastSelected ? unitWoodmacLongTermList : unitList, isWoodmacLongTermForecastSelected ? unitsWoodmacLongTermSelected : unitsSelected, onUnitsChange, { flex: "1" })}
            <Col flex="1">
              <SingleSelectDropdown
                className="buy-con-dropdown-modal cma-dropdown"
                label="From Date"
                childList={cmaPricingFromDates}
                selectedValue={cmaPricingFromDatesSelected}
                setSelectedValue={onPETResinFromDateChange}
              />
            </Col>
            <Col flex="1">
              <SingleSelectDropdown
                className="buy-con-dropdown-modal cma-dropdown"
                label="To Date"
                childList={cmaPricingToDates}
                selectedValue={cmaPricingToDatesSelected}
                setSelectedValue={onPETResinToDateChange}
              />
            </Col>
            {/* {renderPricingFilterDropdown("Unit of Measure", isWoodmacLongTermForecastSelected ? unitWoodmacLongTermList : unitList, isWoodmacLongTermForecastSelected ? unitsWoodmacLongTermSelected : unitsSelected, onUnitsChange, { flex: "1" })} */}
          </Row>

          <Row justify="end" style={{ width: "100%" }}>
            <button className="reset-button" onClick={resetButtonHandler} style={{  marginRight:'0.8rem' }}>
              <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
              <span>Reset Filters</span>
            </button>
          </Row>
        </>
      )}

      {/* Reports Content in Woodmac */}
      {section === "content" && selectedTab === 2 && (
        <Row justify={"start"} style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <Card style={{ height: "100%", padding: "24px", width: "100%" }}>
              {isWoodmacDataLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: 300
                  }}
                >
                  <LoadingSpinner
                    size={{ height: "80px", width: "80px" }}
                  />
                </div>
              ) : renderedWoodmacSections.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    width: "100%", minHeight: '625px'
                  }}
                >
                  <div className="sba-cci-reports-section" style={{ width: "365px" }}>
                    <div className="sba-cci-reports-section-report-title">
                      Repository
                    </div>
                    <div className="sba-cci-reports-accordion-wrap">
                      <AccordionV2
                        className=""
                        onClickAdd={function wRe() {}}
                        onUpdate={function wRe() {}}
                        presentation="box-shadow"
                        selectedItemIndex={woodmacAccordionSelectedIndex}
                        style={{ position: "relative", width: "314px" }}
                      >
                        {renderedWoodmacSections.map(s =>
                          renderSection(cmaPdfReportData[s.key], s.label)
                        )}
                      </AccordionV2>
                    </div>
                  </div>

                  <div
                    className="sba-cci-pdf-section"
                    style={
                      pdfUrl == null
                        ? {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                          }
                        : {}
                    }
                  >
                    {pdfUrl == null ? (
                      <div>
                        <EmptyStateV2
                          className=""
                          description="Select a report from the left panel to preview it here."
                          icon="insert_drive_file"
                          style={{
                            minHeight: "300px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                          }}
                          titleContent="Pick a report to preview"
                        />
                      </div>
                    ) : (
                      <iframe
                        src={`https://mozilla.github.io/pdf.js/web/viewer.html?file=${encodeURIComponent(pdfUrl)}`}
                        width="100%"
                        height="500px"
                        style={{
                          border: "none",
                          height: "100%"
                        }}
                        title="PDF Viewer"
                        loading="eager"
                        allow="cross-origin-isolated"
                      />
                    )}
                  </div>
                </div>
              ) : (
                <EmptyStateV2
                  className=""
                  description="No reports available for the selected category"
                  icon="mobiledata_off"
                  style={{
                    minHeight: "300px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                />
              )}
            </Card>
          </Col>
        </Row>
      )}

      {/* Pricing Content in Woodmac */}
      {section === "content" && selectedTab === 1 && (
        <>
        <Row  justify={"start"} style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <div ref={linechartRef}>
            <Card style={{ height: "100%", padding: "24px", width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  position: "relative",
                  width: "100%"
                }}
              >
                {(isUserDataLoading || isFilterDataLoading || isLineDataLoading) ? (
                  <div className="sba-cci-linechart-section">
                  <SkeletonList count={10} height="30" />
                  </div>
                ) : (
                  <div  className="sba-cci-linechart-section">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                      width: "100%",
                      background: "#fff"
                    }}
                  >
                    <div
                      className="resin_linechart_header"
                      style={{
                        width: "100%",
                        alignItems: "center",
                        textAlign: "left",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "16px"
                      }}
                    >
                      <span className="cma-charts-title">
                        Price Trend
                      </span>
                      <span>
                        <DropdownWithIcons
                          modalRef={linechartRef}
                          kpiName={
                            "Price Trend"
                          }
                          checkPDFDownloaded={checkPDFDownloaded}
                        />
                      </span>
                    </div>
                    <div style={{ marginTop: "-10px" }}>
                      {
                        !isWoodmacLongTermForecastSelected && (
                          <span>
                            <span style={{fontWeight:"700"}}>Grade:</span> {gradeSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Geography:</span> {geographySelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Price Type:</span> {priceTypeSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Price Point:</span> {pricePointSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Price Basis:</span> {priceBasisSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Unit of Measure:</span> {unitsSelected?.[0]?.displayText || "-"}
                          </span>
                        )
                      }

                      {
                         isWoodmacLongTermForecastSelected && (
                          <span>
                            <span style={{fontWeight:"700"}}>Product:</span> {productSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Geography:</span> {geographySelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Price Forecast Series:</span> {priceForecastSeriesSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Price Point:</span> {pricePointSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Unit of Measure:</span> {unitsWoodmacLongTermSelected?.[0]?.displayText || "-"}
                          </span>
                        )
                      }
                      
                    </div>
                    {renderForecastLegend()}
                    {
                        activePricingLineChartData?.series && activePricingLineChartData?.series?.length > 0 && (activePricingLineChartData?.actual?.length > 0 || activePricingLineChartData?.forecast?.length > 0) ?
                          <ResinLineChart
                            rawData={resinChartData}
                            lineChartactualData={resinLineChartActualData}
                            forecastStartLabel={resinForecastStartVal}
                            risiSeriesLineChartIndex={resinSeriesLineChartIndex}
                            firstForecastYearMonth={resinFirstForecastYearMonth}
                            firstForecastKeysToBeMergedActualLAst={resinFirstForecastKeysToBeMergedActualLast}
                            currencySymbol={currencySymbol}
                            isShowProductInTooltip={isWoodmacLongTermForecastSelected}
                          />
                        :<NoData/>
                     }       
                  </div>
                </div>
                )}
              </div>
            </Card>
            </div>
          </Col>
        </Row>
        <Row justify={"start"} style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24}>
            <div ref={cmaTableRef}>
            <Card style={{ height: "100%", padding: "24px", width: "100%" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  position: "relative",
                  width: "100%"
                }}
              >  
              {(isUserDataLoading || isFilterDataLoading || isTableDataLoading) ? (
                  <div className="sba-cci-barchart-section">
                  <SkeletonList count={10} height="30" />
                  </div>
                ) : (
                <div className="sba-cci-barchart-section">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                      width: "100%",
                      background: "#fff"
                    }}
                  >
                    <div
                      className="resin_barchart_header"
                      style={{
                        width: "100%",
                        alignItems: "center",
                        textAlign: "left",
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "16px"
                      }}
                    >
                      <span className="cma-charts-title">
                        Product Price Details
                      </span>
                      <span>
                        <DropdownWithIcons
                          modalRef={cmaTableRef}
                          kpiName={"Product Price Details"}
                          checkPDFDownloaded={checkPDFDownloaded}
                          isTable={true}
                        />
                      </span>
                    </div>

                    <div style={{ marginTop: "-18px" }}>
                      {
                        !isWoodmacLongTermForecastSelected && (
                          <span>
                            <span style={{fontWeight:"700"}}>Grade:</span> {gradeSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Geography:</span> {geographySelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Price Type:</span> {priceTypeSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Price Point:</span> {pricePointSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Price Basis:</span> {priceBasisSelected?.[0]?.displayText || "-"}
                          </span>
                        )
                      }

                      {
                         isWoodmacLongTermForecastSelected && (
                          <span>
                            <span style={{fontWeight:"700"}}>Product:</span> {productSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Geography:</span> {geographySelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Price Forecast Series:</span> {priceForecastSeriesSelected?.[0]?.displayText || "-"} &nbsp; &nbsp;| &nbsp; &nbsp;<span style={{fontWeight:"700"}}>Price Point:</span> {pricePointSelected?.[0]?.displayText || "-"}
                          </span>
                        )
                      }
                      
                    </div>
                    
                    {
                          activePricingTableData?.ProductPriceDetails && activePricingTableData?.ProductPriceDetails?.length > 0 ?
                            <CmaTable tableData={activePricingTableData?.ProductPriceDetails} cmaColumns={cmaColumns}/>
                          :<NoData/>
                    }
                  </div>
                </div>
                )}
               </div>
            </Card>
            </div>
          </Col>
        </Row>
        </>
      )}
    </>
  );
};

export default WoodmacSource;
